import { Link } from 'react-router-dom';
import { useJobs } from '../state';
import { LeftNav } from '../components/nav';
import { JobsList } from '../components/job';
import { styles } from '../constants';

export default function Jobs() {
  return (
    <LeftNav>
      <h2>Jobs</h2>
      <JobsList limit={100} />
    </LeftNav>
  );
}
